// forms
// route page
import { HttpClient } from '@angular/common/http';
import { IMyOptions } from 'ng-uikit-pro-standard';
import { LoginUser } from 'src/app/models/login-user';
import { UserService } from '../../../../services/user_V2.service';
import { ApiResponse } from 'src/app/models/api-response';
import { Component, OnInit, ViewChild } from '@angular/core';
import { AppConfigService } from '../../../../app-config.service.service';
import { Routes, RouterModule, Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { CompanySettingsService } from 'src/app/services/company-settings.service';
import { MapInformationService } from 'src/app/services/map-information.service';
import { ThemeService } from 'src/app/services/theme.service'
import { VariablesService } from 'src/app/services/variables.service'

@Component({
  selector: 'app-login',
  templateUrl: './login-cubeshop.component.html',
  styleUrls: ['./login-cubeshop.component.scss']
})

export class LoginCubeShopComponent implements OnInit {
  @ViewChild('uploader', { static: true })
  uploader: any;
  optionCompanysSelect: Array<any>;
  cardForm: FormGroup;
  submitted = false;
  isLoading = false;
  msgError: string;
  showError = false;
  file: File | null;
  apiBaseUrl: string;
  ecomerceconcode: string;
  showPassword = false;
  typeInputPassword = 'password';
  settings: string;

  dumLoginUser: LoginUser;
  base64Logo: string = 'assets/cube-logo.png';

  constructor(private formBuilder: FormBuilder, private router: Router, private http: HttpClient,
    private userService: UserService, private appConfigService: AppConfigService, private activatedRoute: ActivatedRoute, 
    public settingsCompany: CompanySettingsService,
    public apiConfig: AppConfigService,
    private route: ActivatedRoute, public ThemeService: ThemeService, 
    public VariablesService: VariablesService, public MapInformationService: MapInformationService) {


    this.settings = localStorage.getItem('settings');

    if (!this.settings || this.settings == 'null')
      this.settings = null;

  }

  ngOnInit() {

    this.ThemeService.setNavaBar('navbar-disabled')

    var autoStart = localStorage.getItem('autoStart');

    sessionStorage.clear();
    localStorage.clear();


    this.cardForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]]
    });

    this.apiBaseUrl = this.appConfigService.apiBaseUrl;

    console.log("🚀 ~ LoginCubeShopComponent ~ this.MapInformationService.GetCompanySettings ~ this.appConfigService.env_dev:", this.appConfigService.env_dev)
    if(this.appConfigService.env_dev){
      this.ecomerceconcode = this.appConfigService.ecomerceconcode;
      console.log("🚀 ~ LoginCubeShopComponent ~ this.MapInformationService.GetCompanySettings ~ this.ecomerceconcode:", this.ecomerceconcode)
      return;
    }

    const result = this.getCurrentUrl();
    console.log("🚀 ~ LoginV2Component ~ ngOnInit ~ result:", result)

    let info = {
      method: "Get_CompanyCodeFromURL",
      connectioncode:"cube",
      // url: 'localhost',
      url: result[0],
    }

    this.MapInformationService.GetCompanySettings(info).subscribe(resp => {
      console.log("logo:",resp)
      let data = resp[0]
      let tipo = ""
      switch (data.filestring.toUpperCase()) {
        case "/9J/4": tipo = "jpeg";
          break
        default:
          tipo = "png"
          break
        }

        if (data.filestring != '' && data.filestring != undefined) {
          this.base64Logo = 'data:image/' + tipo + ';base64,' + data.filestring;
        } else {
         /*  this.base64Logo = ''
          console.log("No hay logo") */
        }

        this.ecomerceconcode = data.companycode
        this.ThemeService.setEcomerceconcode(this.ecomerceconcode)
        this.ThemeService.setImgLogo(this.base64Logo)
    })


  
    // this.ecomerceconcode = this.appConfigService.ecomerceconcode;


    this.optionCompanysSelect = [
      { value: '1', label: 'Amazing Control' },
      { value: '2', label: 'CUBE-USA' },
      { value: '3', label: 'South Florida Control' },
      { value: '4', label: 'Template Company' },
      { value: '5', label: 'Travis Brothers' },
    ];

  }

  togglePassword() {
    this.showPassword = !this.showPassword;
    this.typeInputPassword = this.showPassword ? 'text' : 'password';
  }


  encodeStringToBase64(string) {
    // Codificar el string a Base64
    let encodedString = btoa(string);
    return encodedString;
  }
  
  decodeBase64ToString(encodedString) {
    // Decodificar el Base64 al string original
    let decodedString = atob(encodedString);
    return decodedString;
  }

  onSubmit() {
    this.userService.Get_CubeShopLogin({Email: this.cardForm.value.username, Password: this.cardForm.value.password, ConnCode: this.ecomerceconcode}).subscribe(result =>  {
      if (result.connected) {
        console.log("🚀 ~ LoginCubeShopComponent ~ onSubmit ~ result:", result)
        localStorage.setItem('token', result.token);
        localStorage.setItem('userName', result.userName);
        localStorage.setItem('userID', result.userID);
        localStorage.setItem('email', this.cardForm.value.username);
        localStorage.setItem('userData', JSON.stringify(result))
        let encode = this.encodeStringToBase64(this.cardForm.value.password)
        localStorage.setItem('p455', encode)
        this.ThemeService.setNavaBar('navbar-active')
        this.VariablesService.setUserName(result.userName)
        this.router.navigateByUrl('/partList');
      } 
      else {
        this.showError = true;
        this.msgError = 'Invalid username or password';
      }
    })

    return 0;
    

    this.showError = false;
    this.msgError = '';
    this.submitted = true;
    // stop here if form is invalid
    if (this.cardForm.invalid) {
      return;
    }
    this.isLoading = true;
    let value = this.cardForm.value;
    this.userService.login(value).subscribe((data: ApiResponse) => {
      if (data.connected) {
        localStorage.clear();

        if (this.settings)
        localStorage.setItem('settings', this.settings);
        localStorage.setItem('termaccepted', data.termAccepted.toString());
        localStorage.setItem('token', data.token);
        localStorage.setItem('userName', data.userName);
        localStorage.setItem('isClient', data.isClient);
        localStorage.setItem('customerid', data.customerID);
        localStorage.setItem('email', value.username);
        localStorage.setItem('currentLat', data.lat);
        localStorage.setItem('currentLong', data.long);
        localStorage.setItem('ubicacion', data.ubicacion);
        this.userService.currentUserName.next(data.userName);
        this.userService.isClient.next(JSON.parse(data.isClient.toLocaleLowerCase()));

        if (data.customerID) {
          this.userService.Get_UserSettingsCE(data.customerID).subscribe(result => {

            if (result.length > 0 && result[0].CLIENTUSERSETTING) {
              let obj = JSON.parse(result[0].CLIENTUSERSETTING);
              obj.regionid = result.RegionID;

              localStorage.setItem('settings', JSON.stringify(obj));
              localStorage.setItem('UserCompanyName', result[0].UserCompanyName);

              // This code detect boostrap screen standar resolution. Its used to start always
              // with home page if its mobile screen *************************
              const width = Math.max(
                document.documentElement.clientWidth,
                window.innerWidth || 0
              )
              var screenType = 'xl';
              if (width <= 576) { screenType = 'xs' }
              if (width <= 768) { screenType = 'sm' }
              if (width <= 992) { screenType = 'md' }
              if (width <= 1200) { screenType = 'lg' }
              var ignoreStartPage = false;
              if (screenType == 'xs' || screenType == 'sm') { ignoreStartPage = true }


              this.userService.settings.next(obj);

              this.userService.settings.next(obj);

              let goto = obj.startPage && !ignoreStartPage ? obj.startPage : '/home';
              this.router.navigateByUrl(goto);
            } else {
              this.router.navigateByUrl('/home');
            }
          }, err => {
            this.router.navigateByUrl('/home');
          }
          );
        }


        // this.router.navigateByUrl('/home');
      } else {
        this.showError = true;
        this.msgError = 'Invalid username or password';
      }
    }, error => {
      this.showError = true;
      this.msgError = 'Server internal error, please contact the administrator!';
    });
    this.submitted = false;
    this.isLoading = false;
  }
  gotoEstimate() {
  }
  public myDatePickerOptions: IMyOptions = {
    // Your options
  }

  getCurrentUrl(): string[] {
    const url = window.location.href;
    // const url = 'https://sfc.cube-usa.com'
  
    const cleanUrl = url.replace(/^https?:\/\//, '');
  
    const parts = cleanUrl.split('.');
  
    return parts;
  }

}
